import { StyleSheet, Dimensions } from "react-native";

const { width } = Dimensions.get("window");
const isSmallScreen = width < 768;

const styles = StyleSheet.create({
  mainContainer: {
    width: isSmallScreen ? 280 : null,
    flexWrap: "wrap",
    flexDirection: isSmallScreen ? "column" : "row",
    paddingVertical: 16,
    paddingHorizontal: 16,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  contentContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  saldoTotalAtivos: {
    fontFamily: "'Poppins', sans-serif",
    textTransform: "uppercase",
    fontSize: 16,
    textAlign: "left",
    color: "#077A97",
    marginBottom: 6,
  },
  ativos: {
    width: "100%",
    marginTop: 8,
    flexWrap: "wrap",
    fontSize: 14,
  },

  saldoAtivos: {
    flexWrap: "wrap",
    fontSize: 16,
  },
  textTotalAtivos: {
    marginBottom: 20,
    fontSize: 26,
    textAlign: "left",
  },
  containerAtivos: {
    flexWrap: "wrap",
    alignSelf: "flex-start",
    flexDirection: "row",
    marginBottom: 6,
  },

  ativosInfoRow: {
    flexDirection: "row",
    flexWrap: "wrap",
  },

  textContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
  },
  img: {
    alignSelf: "center",
    marginRight: 12,
    minWidth: 24,
    minHeight: 24,
    maxWidth: 24,
    maxHeight: 24,
    borderRadius: 50,
  },
  chartContainer: {
    paddingRight: 20,
    width: "80%",
    alignItems: "flex-end",
    justifyContent: "center",
  },

  graphTitle: {
    fontWeight: 600,
    fontSize: 16,
    color: "#077A97",
    marginBottom: 6,
  },

  containerTitleEye: {
    alignSelf: "flex-start",
    flexDirection: "row",
    gap: 20,
    justifyContent: "space-evenly",
  },

  legendContainer: {
    marginTop: 10,
    alignItems: "flex-start",
  },
  legendItem: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 2,
  },
  legendColorBox: {
    width: 16,
    height: 16,
    borderRadius: 8,
    marginRight: 10,
  },
  legendText: {
    fontSize: 14,
    color: "#000",
  },

  containerSaldo: {
    flexDirection: isSmallScreen ? "column" : "row",
    width: "100%",
    flexWrap: "wrap",
    alignItems: "flex-start",
  },
  containerColumn: { flexDirection: "column", alignItems: "flex-start" },

  containerRow: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  container: {
    flex: 1,
    padding: 10,
    backgroundColor: "#fff",
  },

  paginationControls: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 20,
  },
  paginationButton: {
    padding: 10,
    backgroundColor: "#077A97",
    color: "#fff",
    borderRadius: 5,
    marginHorizontal: 5,
  },
  paginationButtonDisabled: {
    padding: 10,
    backgroundColor: "#ccc",
    color: "#fff",
    borderRadius: 5,
    marginHorizontal: 5,
  },
  paginationText: {
    fontSize: 16,
    color: "#333",
  },
  loadingIndicator: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  paginationDotsContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginHorizontal: 10,
  },

  paginationDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    marginHorizontal: 5,
  },

  graphTitle: {
    fontFamily: "'Poppins', sans-serif",
    textTransform: "uppercase",
    fontSize: 16,
    textAlign: "left",
    color: "#077A97",
    marginBottom: 8,
  },

  legendaGrafico: {
    fontSize: 14,
    fontFamily: "'Poppins', sans-serif",
    color: "#077A97",
    marginBottom: 6,
  },

  txtMioloGraph: {
    fontSize: 40,
    fontWeight: "bold",
    color: "#077A97",
    textAlign: "center",
  },
});

export default styles;
